import { useState } from "react";

export const Switch = ({ enabled: initial = false, onChange }) => {
    const [enabled, setEnabled] = useState(initial);

    const handleToggle = () => {
        setEnabled(!enabled);
        onChange?.(!enabled);
    };

    return (
        <label className="relative flex items-center cursor-pointer">
            <input
                type="checkbox"
                checked={enabled}
                onChange={handleToggle}
                className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-[#0092B8] peer-focus:ring-2 peer-focus:ring-[#0092B8] transition-colors duration-300"></div>
            <div className="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow-md peer-checked:translate-x-full transition-transform duration-300"></div>
        </label>
    );
};